import { Sprite } from 'pixi.js'
import { signal } from 'services/SignalsService'
import { reelsSettings } from 'settings/custom/reels'
import { Device } from 'utils/Device'

export default class BookSymbol extends PIXI.Container {
  constructor(data) {
    super()
    signal.on('SHOW:SYMBOL', this.changeSymbols.bind(this))
    signal.on('STATE:IN:FS-START', this.reset.bind(this))
    if (data.infinitySymb) {
      signal.on('ACTION:FS-START', this.changeInfinitySymbol.bind(this))
    }
  }

  reset() {
    this.removeChildren()
  }

  changeSymbols(symbol) {
    this.removeChildren()
    const sprite = Sprite.from(`${reelsSettings.items.states.static.path}${symbol}.png`)
    sprite.scale.set(Device.isDesktop() ? 1 : 0.5)
    this.addChild(sprite)
  }

  changeInfinitySymbol() {
    this.removeChildren()
    const symbol = game.models.FreespinModel.get().expendingSymbol
    const sprite = Sprite.from(`${reelsSettings.items.states.static.path}${symbol}.png`)
    sprite.anchor.set(0.5)
    this.addChild(sprite)
  }
}
